module.exports = __webpack_public_path__ + "img/clear-day.4b9869a6.svg";